/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": process.env.REACT_APP_AWS_REGION || "us-east-2",
    "aws_appsync_graphqlEndpoint": process.env.REACT_APP_APPSYNC_ENDPOINT || "https://hzhhsghfijfrbpwcrlr73ludze.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": process.env.REACT_APP_AWS_REGION || "us-east-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": process.env.REACT_APP_APPSYNC_API_KEY
};

export default awsmobile;
